import OmegaRepository from '@/_shared/repositories/omega.respository';
import RepTerms from '@/profile/business-partner-info/entities/rep-terms.entity';
import BackofficeServicesRepository from '@/_shared/repositories/backoffice-services.repository';
import UplineBP from '@/profile/interfaces/upline.entity';
import PayoneerData from '../entities/payoneer-data.interface';
import PayoutMethod from '../entities/payout-methods.interface';
import RepConsumptionData from '../entities/rep-consumption.interface';
import UplineBps from '../entities/upline-bps.inteface';

class BusinessPartnerInfoService {
  private omegaRepository: OmegaRepository = new OmegaRepository();
  private backOfficeRepository: BackofficeServicesRepository = new BackofficeServicesRepository();

  public retrieveRepTerms(repDid: number): Promise<RepTerms> {
    return this.omegaRepository.get(`rep/info/${repDid}?include=recognition_name,agreement_link,registration_confirmation_link&includeKV=true`, { withCredentials: false })
      .then((response) => new RepTerms(response.data.rep));
  }

  public getDistributorConsumption(repDid: number): Promise<RepConsumptionData> {
    return this.omegaRepository.get(`rep/${repDid}/profile?include=consumption`, { withCredentials: false })
      .then((response) => response.data.rep);
  }

  public createDistributorConsumptionAccount(repDid: number): Promise<{customerDID: string}> {
    return this.omegaRepository.put(`rep/${repDid}/consumption`, { withCredentials: false })
      .then((response) => response.data);
  }

  public getUpline(repDID: number): Promise<UplineBps> {
    return this.omegaRepository.get(`rep/${repDID}/upline`, { withCredentials: false })
      .then((response) => ({
        sponsor: new UplineBP(response.data.sponsor),
        placement: new UplineBP(response.data.placement),
      }));
  }

  public getPayoutMethod(repDID: number): Promise<PayoutMethod> {
    return this.omegaRepository.get(`rep/${repDID}/profile/payoutmethod`, { withCredentials: false })
      .then((response) => response.data);
  }

  public updateSession(action: string) {
    const formData = new FormData();
    formData.append('action', action);

    return this.omegaRepository.post('login/session', formData, { withCredentials: true })
      .then((response) => response.data);
  }

  public getPayoneer(repDID: number): Promise<PayoneerData> {
    return this.backOfficeRepository.get(`distributors/payoneer/${repDID}`).then((data) => Object.assign(data.data, {
      url: data.data.url ? data.data.url : data.data.data,
    }));
  }
}

export default new BusinessPartnerInfoService();
